const state = {
    user: null,
    isLogged: false,
    isImpersonating: false,
    impersonatorUser: null,
    originalToken: null,
}

const getters = {}

const mutations = {
    SET_AUTH_USER(state, payload) {
        state.user = payload
    },
    LOGIN(state, payload) {
        state.isLogged = payload
    },
    SET_IMPERSONATING(state, payload) {
        state.isImpersonating = payload
    },
    SET_IMPERSONATOR_USER(state, payload) {
        state.impersonatorUser = payload
    },
    SET_ORIGINAL_TOKEN(state, payload) {
        state.originalToken = payload
    },
}

const actions = {
    me: async ({commit, state}) => {
        try {
            const data = await window.http.get('api/auth/me', {loading:false})
            if (data.error) {
                commit('LOGIN', false)
                return null
            }
            commit('SET_AUTH_USER', data)
            if (!state.isLogged) {
                commit('LOGIN', true)
            }

            const userData = data.data || data
            if (userData.impersonator) {
                commit('SET_IMPERSONATING', true)
                commit('SET_IMPERSONATOR_USER', userData.impersonator)
            }

            localStorage.setItem('userData', JSON.stringify(data))
            return data
        } catch (error) {
            commit('LOGIN', false)
            return error
        }
    },
    setUser: async ({commit}, user) => {
        commit('SET_AUTH_USER', user)
    },
    logoutAction: ({commit}) => {
        commit('LOGIN', false)
    },

    setToken: async ({commit}, payload) => {
        const data = {
            token: payload.token,
            type: 'web',
        }
        const response = await window.http.post(`v2/users/${payload.user}/push-token`, data, {loading:false})
        if (response.error) {
            return null
        }
        return 'ok'
    },

    startImpersonate: async ({commit, dispatch}, payload) => {
        if (!payload?.access_token) return
        const originalToken = localStorage.getItem('accessToken')
        commit('SET_ORIGINAL_TOKEN', originalToken)
        localStorage.setItem('originalToken', originalToken)
        localStorage.setItem('accessToken', payload.access_token)
        commit('SET_IMPERSONATING', true)
        commit('SET_IMPERSONATOR_USER', payload.impersonator)
        await dispatch('me')
    },

    stopImpersonate: async ({commit, state, dispatch}) => {
        const originalToken = state.originalToken || localStorage.getItem('originalToken')
        if (originalToken) {
            localStorage.setItem('accessToken', originalToken)
        }
        localStorage.removeItem('originalToken')
        commit('SET_IMPERSONATING', false)
        commit('SET_IMPERSONATOR_USER', null)
        commit('SET_ORIGINAL_TOKEN', null)
        await dispatch('me')
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
